module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("Copyright © 2008 Fordham University Press")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Dis-Enclosure")]), _vm._v(" was originally published in French as Jean-Luc Nancy, "), _c('em', [_vm._v("La déclosion (Déconstruction du christianisme, 1),")]), _vm._v(" "), _c('em', [_vm._v("©")]), _vm._v(" 2005, Éditions Galilée.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("This work has been published with the assistance of the National Center for the Book—French Ministry of Culture.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Ouvrage publié avec le concours du Ministère français chargé de la culture—Centre"), _c('br'), _vm._v("National du Livre.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data is available.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed in the United States of America"), _c('br'), _vm._v("10 09 08     5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-662c7b76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 72
// module chunks = 0